import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../../../services/api';
import { userMessage } from '../../../../utils/vy-toasts';
import { isError } from '@vy/utils';
import type { PaddleExportInvoicesRequestPayload } from '@vy/api-definition';
import { queryKeys } from '../../../../services/query-key/query-keys';

export function usePaddleExportInvoices(
  options?: UseMutationOptions<void, unknown, PaddleExportInvoicesRequestPayload>,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['paddleExportInvoices'],
    mutationFn: async ({ invoiceIds }) => {
      const api = getPrivateApi();

      return api.paddleExportInvoices({
        paddleExportInvoicesRequest: {
          invoiceIds,
        },
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries(queryKeys.jobs());
    },
    onError: (error) => {
      if (isError(error)) {
        userMessage('error', error.message);
      }
    },
    ...options,
  });
}
